import Gallery from "./Gallery.component";

export default Gallery;
